import type { ErrorReference } from '../../types';

export const TRANSACTIONS_SYNC_MUTATION_DURING_PAGINATION: ErrorReference = {
  server: {
    error_type: 'TRANSACTIONS_ERROR',
    error_code: 'TRANSACTIONS_SYNC_MUTATION_DURING_PAGINATION',
    error_message:
      'Underlying transaction data changed since last page was fetched. Please restart pagination from last update.',
    display_message: null,
    http_code: 400,
  },
  link: null,
};

export const TRANSACTIONS_SYNC_ITEM_LIMIT_EXCEEDED: ErrorReference = {
  server: {
    error_type: 'TRANSACTIONS_ERROR',
    error_code: 'TRANSACTIONS_SYNC_ITEM_LIMIT_EXCEEDED',
    error_message:
      'This Item has too many transactions for Transactions Sync to return updates. Do not retry or restart pagination for this Item. Use /transactions/get (or /processor/transactions/get for processor integrations) to retrieve transactions instead, or contact Plaid Support for assistance.',
    display_message: null,
    http_code: 400,
  },
  link: null,
};
